// images
import img1 from '../images/service/1.jpg'
import img2 from '../images/service/2.jpg'
import img3 from '../images/service/3.jpg'
import img4 from '../images/service/2.jpg'

/* Single image */
import simg1 from '../images/service-single/img-1.jpg'
import simg2 from '../images/service-single/img-2.jpg'
import simg3 from '../images/service-single/img-3.jpg'
import simg5 from '../images/service-single/img-5.jpg'




const Services = [
    {
        id: 1,
        image: img1,
        icon: 'flaticon-fund',
        simage: simg1,
        title: 'Daily Prayers',
        subtitle: 'Five daily prayers in congregation',
        description: 'We warmly invite you to join us for the five daily prayers in a peaceful and spiritually enriching environment. Our prayer hall provides a comfortable space for both brothers and sisters to connect with Allah and strengthen their faith alongside fellow community members. Experience the barakah of praying in congregation and feel the warmth of our growing Point Cook Muslim family.',
        slug: 'Daily-Prayers',
        pageContent: {
            intro: 'We warmly invite you to join us for the five daily prayers in a peaceful and spiritually enriching environment. Our prayer hall provides a comfortable space for both brothers and sisters to connect with Allah and strengthen their faith alongside fellow community members.',
            sectionTitle: 'The Importance of Congregational Prayer',
            sectionContent: 'Praying in congregation (Jama\'ah) holds immense virtue in Islam, with rewards multiplied twenty-seven times compared to praying alone. At PCIC, we strive to make every prayer a meaningful experience that strengthens your connection with Allah and your fellow Muslims. Our prayer times follow the local timetable, and we welcome everyone—whether you\'re a regular attendee or visiting for the first time.',
            highlightTitle: 'Why Pray With Us?',
            highlightContent: 'Experience the barakah of praying shoulder to shoulder with your brothers and sisters in faith.',
            features: [
                'Comfortable prayer halls for brothers and sisters',
                'Prayer times announced via our community channels',
                'Welcoming atmosphere for new Muslims and visitors'
            ],
            quote: 'The prayer in congregation is twenty-seven times superior to the prayer offered by a person alone. - Prophet Muhammad (PBUH)'
        }
    },
    {
        id: 2,
        image: img2,
        icon: 'flaticon-first-aid-kit',
        simage: simg2,
        title: 'Islamic Education',
        subtitle: 'Quran and Islamic studies classes',
        description: 'Nurture your family\'s Islamic knowledge with our comprehensive education programmes designed for all ages. From Quran recitation and memorisation to Arabic language and Islamic studies, our dedicated teachers provide quality instruction in a supportive learning environment. Whether you\'re starting your child\'s Islamic journey or seeking to deepen your own understanding, we\'re here to guide you every step of the way.',
        slug: 'Islamic-Education',
        pageContent: {
            intro: 'Nurture your family\'s Islamic knowledge with our comprehensive education programmes designed for all ages. From Quran recitation and memorisation to Arabic language and Islamic studies, our dedicated teachers provide quality instruction in a supportive learning environment.',
            sectionTitle: 'Programmes for All Ages',
            sectionContent: 'Whether you\'re starting your child\'s Islamic journey or seeking to deepen your own understanding, we\'re here to guide you every step of the way. Our classes cater to children, youth, and adults, with flexible schedules to suit busy families. Our qualified teachers combine traditional Islamic scholarship with modern teaching methods to make learning engaging and effective.',
            highlightTitle: 'What We Offer',
            highlightContent: 'A nurturing environment where every learner can grow in knowledge and faith.',
            features: [
                'Quran recitation, Tajweed, and memorisation (Hifz)',
                'Arabic language for beginners to advanced',
                'Islamic studies covering Aqeedah, Fiqh, and Seerah'
            ],
            quote: 'The best among you are those who learn the Quran and teach it. - Prophet Muhammad (PBUH)'
        }
    },
    {
        id: 3,
        image: img3,
        icon: 'flaticon-charity',
        simage: simg3,
        title: 'Community Support',
        subtitle: 'Welfare and support services',
        description: 'At PCIC, we believe in looking after one another as one community. Our welfare services provide compassionate support for families facing challenges, including counselling, practical assistance, and connection to essential resources. No one should face difficulties alone—reach out to us in confidence, and let us help you navigate life\'s challenges with the support of your community.',
        slug: 'Community-Support',
        pageContent: {
            intro: 'At PCIC, we believe in looking after one another as one community. Our welfare services provide compassionate support for families facing challenges, including counselling, practical assistance, and connection to essential resources.',
            sectionTitle: 'Supporting Our Community Members',
            sectionContent: 'No one should face difficulties alone. Whether you\'re experiencing financial hardship, family challenges, or simply need someone to talk to, we\'re here to help. Our support services are provided with complete confidentiality and respect, following the Islamic principles of caring for one another. We work with local services to ensure you receive the assistance you need.',
            highlightTitle: 'How We Can Help',
            highlightContent: 'Reach out to us in confidence, and let us help you navigate life\'s challenges with the support of your community.',
            features: [
                'Confidential counselling and pastoral care',
                'Emergency financial assistance for families in need',
                'Connection to community resources and services'
            ],
            quote: 'The believers in their mutual kindness, compassion, and sympathy are just like one body. - Prophet Muhammad (PBUH)'
        }
    },
    {
        id: 4,
        image: img4,
        icon: 'flaticon-gift-box',
        simage: simg5,
        title: 'Community Events',
        subtitle: 'Regular gatherings and celebrations',
        description: 'Celebrate the beauty of Islam together with your Point Cook community. From joyous Eid celebrations and blessed Ramadan iftars to family fun days and educational seminars, our events bring us together in faith and fellowship. These gatherings strengthen the bonds between families and create lasting memories for our children. We look forward to welcoming you and your family at our next event.',
        slug: 'Community-Events',
        pageContent: {
            intro: 'Celebrate the beauty of Islam together with your Point Cook community. From joyous Eid celebrations and blessed Ramadan iftars to family fun days and educational seminars, our events bring us together in faith and fellowship.',
            sectionTitle: 'Building Bonds Through Gathering',
            sectionContent: 'These gatherings strengthen the bonds between families and create lasting memories for our children. Our events are designed to be inclusive and family-friendly, providing opportunities for community members to connect, learn, and celebrate together. Whether it\'s the joy of Eid morning, the spiritual atmosphere of Ramadan nights, or the fun of a community barbecue, there\'s something for everyone.',
            highlightTitle: 'Our Events Include',
            highlightContent: 'We look forward to welcoming you and your family at our next event.',
            features: [
                'Eid prayers and celebrations',
                'Ramadan iftars and Tarawih prayers',
                'Family fun days and community barbecues'
            ],
            quote: 'Whoever believes in Allah and the Last Day, let him be generous to his guest. - Prophet Muhammad (PBUH)'
        }
    },

];
export default Services;